"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGooglePlaces = exports.once = exports.loadPlacesLib = void 0;
const react_1 = require("react");
const PLACES_KEY = process.env.GOOGLE_PLACES_API_KEY || 'GOOGLE_PLACES_API_KEY_ENV_UNSET_ERROR';
const loadPlacesLib = (key) => new Promise((res) => {
    const d = document;
    const s = d.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = 'https://maps.googleapis.com/maps/api/js?libraries=places&key=' + key;
    s.onload = () => { res(); };
    const x = d.getElementsByTagName('script')[0];
    if (x && x.parentNode)
        x.parentNode.insertBefore(s, x);
});
exports.loadPlacesLib = loadPlacesLib;
const once = (fn) => {
    let f = fn;
    return (() => __awaiter(void 0, void 0, void 0, function* () {
        if (f) {
            const p = f();
            f = null;
            yield p;
        }
    }));
};
exports.once = once;
const loadApi = (0, exports.once)(() => __awaiter(void 0, void 0, void 0, function* () {
    yield (0, exports.loadPlacesLib)(PLACES_KEY);
}));
const useGooglePlaces = () => {
    const [loaded, setLoaded] = (0, react_1.useState)(false);
    const [loading, setLoading] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (!loaded && !loading) {
            setLoading(true);
            loadApi()
                .then(() => setLoaded(true))
                .catch(console.error)
                .then(() => setLoading(false));
        }
    });
    return loaded;
};
exports.useGooglePlaces = useGooglePlaces;
exports.default = {
    useLoadGoogleApi: exports.useGooglePlaces
};
//# sourceMappingURL=loader.js.map